import Vue from 'vue'

// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'

// Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getRemoteConfig, fetchAndActivate } from 'firebase/remote-config'

let firebaseInterval
let isAppActive = true
export default async function(ctx, inject) {
  try {
    if (firebaseInterval) {
      clearInterval(firebaseInterval)
    }

    setIsAppActive()

    // Your web app's Firebase configuration
    const firebaseConfig = {
      apiKey: process?.env?.firebaseApiKey,
      authDomain: 'daikin-pwa-cbaf9.firebaseapp.com',
      projectId: 'daikin-pwa-cbaf9',
      storageBucket: 'daikin-pwa-cbaf9.appspot.com',
      messagingSenderId: '977498411420',
      appId: '1:977498411420:web:836030e58dcc7a4137f859'
    }
    const milliseconds = process?.env?.envName !== 'master' ? 60000 : 3600000
    // Initialize Firebase
    const app = initializeApp(firebaseConfig)
    // Initialize Remote Config and get a reference to the service
    const remoteConfig = await getRemoteConfig(app)

    if (remoteConfig?.settings) {
      remoteConfig.settings.minimumFetchIntervalMillis = milliseconds
    }

    // For Firefox only
    if (navigator?.userAgent?.includes('Firefox') && window?.indexedDB) {
      const db = await indexedDB?.open('test')
      if (db && ctx && remoteConfig)
        db.onsuccess = () => {
          try {
            firebaseInterval = setInterval(async () => {
              await fetchAndSetFirebase(remoteConfig, milliseconds)
            }, milliseconds)
          } catch (error) {
            console.log('Error fetching Firebase Remote Config:', error)
          }
        }
    } else {
      // Start polling but respect app state
      firebaseInterval = setInterval(async () => {
        /* if (ctx?.$nativeWebviewDebugger) {
          ctx.$nativeWebviewDebugger('isAppActive', { isAppActive })
        } */

        if (!isAppActive) {
          // console.log('App in background, skipping fetch')
          return
        }
        try {
          await fetchAndSetFirebase(remoteConfig, milliseconds)
        } catch (error) {
          console.log('Firebase Remote Config fetch failed', error)
        }
      }, milliseconds)
    }

    await fetchAndSetFirebase(remoteConfig, milliseconds)
  } catch (error) {
    console.log(error)
  }

  async function fetchAndSetFirebase(remoteConfig) {
    await fetchAndActivate(remoteConfig).catch((error) => {
      console.log('Firebase Remote Config fetch failed', error)
    })
    await updateFeatureFlag(ctx, remoteConfig)
  }

  function setIsAppActive() {
    document.addEventListener('visibilitychange', () => {
      isAppActive = !document?.hidden
    })

    // iOS
    window.addEventListener('pagehide', () => {
      isAppActive = false
    })
    window.addEventListener('pageshow', () => {
      isAppActive = true
    })

    // Android
    document.addEventListener('pause', () => {
      isAppActive = false
    })
    document.addEventListener('resume', () => {
      isAppActive = true
    })
  }

  async function updateFeatureFlag(ctx, remoteConfig) {
    let featureFlag
    if (remoteConfig?._storageCache?.activeConfig?.featureFlag) {
      featureFlag = JSON.parse(
        remoteConfig?._storageCache?.activeConfig?.featureFlag
      )
    }

    let featureFullyVisibleOnEnvironment
    if (
      remoteConfig?._storageCache?.activeConfig
        ?.featureFullyVisibleOnEnvironment
    ) {
      featureFullyVisibleOnEnvironment = JSON.parse(
        remoteConfig?._storageCache?.activeConfig
          ?.featureFullyVisibleOnEnvironment
      )
    }

    if (featureFlag && featureFullyVisibleOnEnvironment) {
      Vue.prototype.$firebase = {
        remoteConfig: { featureFlag, featureFullyVisibleOnEnvironment }
      }

      if (ctx && inject) {
        ctx.$firebase = {
          remoteConfig: { featureFlag, featureFullyVisibleOnEnvironment }
        }
        inject('firebase', {
          remoteConfig: { featureFlag, featureFullyVisibleOnEnvironment }
        })
      }

      await ctx.app.store.dispatch('feature-flag/setLoadedFeatureFlag', true)
    }
  }
}
